import styled from "styled-components";

export const CurrentStories = styled.div`
  display: flex;
  justify-content: space-between;
  background: #F9F2EC;
  border: 1px solid #E4D7CD;
  padding: 18px 24px;
  margin-bottom: 16px;
  border-radius: 8px;
`
export const StoriesItem = styled.div<{current: boolean}>`
  display: flex;
  justify-content: space-between;
  background: ${({current}) => current && "#BD987F33"};
  padding: 10px 18px;
  border-radius: 8px;
`